import { render, staticRenderFns } from "./projectEdit.vue?vue&type=template&id=ffe21036&"
import script from "./projectEdit.vue?vue&type=script&lang=js&"
export * from "./projectEdit.vue?vue&type=script&lang=js&"
import style0 from "./projectEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports